<template>
  <div style="width:150px">
    <form class="position-relative" method="post" @submit.prevent="assignBarcode">
      <!--<button v-if="processing" type="submit" class="btn position-absolute" style="right:0"><i class="fas fa-circle-notch fa-spin"></i></button>
      <input v-model="barcode" type="text" class="form-control" required>-->
      <textarea v-model="barcodes" class="form-control" :rows="barcodeRows" @keyup.enter="updateTextareaHeight" @keyup.delete="updateTextareaHeight" style="overflow:hidden"></textarea>
      <button type="submit" class="btn btn-primary btn-block mt-2" :disabled="!barcodes || processing">
        <i v-if="processing" class="fas fa-circle-notch fa-spin"></i>
        Add Units
      </button>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OrderProductAssignBarcodes',
  components: {
    axios
  },
  props: ['order_id', 'order_product'],
  data () {
    return {
      barcode: null,
      barcodes: null,
      barcodeRows: 1,
      processing: false
    }
  },
  methods: {
    updateTextareaHeight () {
      let rows = this.barcodes ? this.barcodes.split(/\r\n|\r|\n/).length : 1
      this.barcodeRows = rows > 1 ? rows : 1
    },
    assignBarcode () {
      if (!this.barcodes || this.barcodes.length < 1) {
        this.$toast.error('Please provide barcodes of the units.')
        return false
      }

      this.processing = true

      axios.post(process.env.URLS_POS_API + '/orders/' + this.order_id + '/products/' + this.order_product.id + '/units', {
        barcodes: (this.barcodes.replace(/(^(\r\n|\r|\n))|((\r\n|\r|\n)$)/, '')).split(/\r\n|\r|\n/)
      }).then((response) => {
        if (typeof response.data.status === 'undefined' || !response.data.status) {
          this.$toast.error(typeof response.data.msg !== 'undefined' ? response.data.msg : 'An unknown error occurred')
          return false
        }

        this.$parent.product.product_units = response.data.product_units
        this.$parent.product.pending_product_units = response.data.pending_product_units
        this.$parent.product.to_be_fulfilled = response.data.to_be_fulfilled
        this.$parent.product.status = response.data.order_product_status
      }).catch(error => {
        let errorMessage = 'Failed to add the barcoded unit to the order.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage += ' ' + error.response.data.message
        }
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)
      }).finally(() => {
        this.processing = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/order/partials/ProductAssignBarcodes.vue